import React from "react";
import { I18n } from "@aws-amplify/core";
import { map, get, isEmpty, forEach, sortBy, size, includes } from "lodash";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import OnsiteCountsDetailsRow from "./OnsiteCountsDetailsRow";
import ScrollableTable from "../../Common/Table/ScrollableTable";
import OnsiteCountsCsv from "./OnsiteCountsCsv";
import OnsiteCountDialog from "./OnsiteCountDialog";
import { getProfileTypeIcon } from "../../../utils/profile";

const OnsiteCountsDetails = (props) => {
  const { data, refresh, expandedSites, setExpandedSites } = props;
  const [open, setOpen] = React.useState(false);
  const [filters, setFilters] = React.useState(props.filters);

  React.useEffect(() => {
    setFilters(props.filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.filters)]);

  const openDialog = (newFilters) => {
    setOpen(true);
    setFilters({
      ...filters,
      ...newFilters,
    });
  };

  if (isEmpty(data)) {
    return null;
  }

  let columns = [
    { name: "profiles_sites", minWidth: 200, width: 200 },
    { name: "companies_zones", minWidth: 200, width: 200 },
  ];

  forEach(
    sortBy(get(data, ["profile_types"]), (t) => t.id),
    (type) => {
      columns.push({
        icon: getProfileTypeIcon(get(type, ["id"])),
        minWidth: 76,
        width: 76,
      });
    }
  );

  columns.push({
    name: "dashboard_total",
    minWidth: 76,
    width: 76,
  });

  return (
    <Box>
      <OnsiteCountDialog
        open={open}
        setOpen={setOpen}
        onClose={refresh}
        filters={filters}
      />
      <Grid container>
        <Grid item xs>
          {I18n.get("site_details")}
        </Grid>
        <OnsiteCountsCsv data={data} />
      </Grid>
      <ScrollableTable columns={columns}>
        {map(get(data, ["sites"]), (s, i) => (
          <OnsiteCountsDetailsRow
            key={i}
            data={s}
            index={i}
            openDialog={openDialog}
            defaultExpand={
              size(get(data, ["sites"])) === 1 ||
              includes(expandedSites, s.site_id)
            }
            expandedSites={expandedSites}
            setExpandedSites={setExpandedSites}
          />
        ))}
      </ScrollableTable>
    </Box>
  );
};

export default OnsiteCountsDetails;
